/*
 * PRORA — entry CSS.
 *
 * Tailwind v4: import singolo + custom-variant per dark mode in modalità "class".
 * Il preloader anti-flash in index.html applica/rimuove la classe `dark` su <html>
 * prima che React monti.
 */

@import "tailwindcss";

/* Strategia dark: variant si attiva quando un antenato ha class="dark".
   Equivalente al vecchio `darkMode: 'class'` di Tailwind v3. */
@custom-variant dark (&:where(.dark, .dark *));

@media print {
  html,
  body {
    background: #ffffff !important;
    color: #0f172a !important;
  }

  .no-print {
    display: none !important;
  }

  .print-surface {
    max-width: none !important;
    padding: 0 !important;
  }

  .print-card {
    break-inside: avoid;
    box-shadow: none !important;
    border-color: #cbd5e1 !important;
  }
}
